const cloudinaryConfig = {
    BASE_URL: "https://api.cloudinary.com/v1_1/",
    UPLOAD_SUFFIX: "/auto/upload",
    DELETE_SUFFIX: "/image/destroy",
}

export default cloudinaryConfig;